"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var date_range_picker_helper_1 = require("./date-range-picker.helper");
var input_base_component_1 = require("../input-base/input-base.component");
var date_range_1 = require("../../models/date-range");
var DateRangePickerComponent = (function (_super) {
    __extends(DateRangePickerComponent, _super);
    function DateRangePickerComponent(ele) {
        var _this = _super.call(this, ele) || this;
        _this.ele = ele;
        _this.parentEl = $('body');
        _this.startDate = moment().startOf('day').toString();
        _this.endDate = moment().endOf('day').toString();
        _this.dateLimit = false;
        _this.autoApply = false;
        _this.singleDatePicker = false;
        _this.showDropdowns = false;
        _this.showWeekNumbers = false;
        _this.showISOWeekNumbers = false;
        _this.showCustomRangeLabel = true;
        _this.timePicker = false;
        _this.timePicker24Hour = false;
        _this.timePickerIncrement = 1;
        _this.timePickerSeconds = false;
        _this.linkedCalendars = true;
        _this.autoUpdateInput = true;
        _this.alwaysShowCalendars = false;
        _this.ranges = {};
        _this.buttonClasses = 'btn btn-sm';
        _this.applyClass = 'btn-success';
        _this.cancelClass = 'btn-default';
        _this.rangeChanged = new core_1.EventEmitter();
        _this.isShowing = false;
        _this.leftCalendar = {};
        _this.rightCalendar = {};
        return _this;
    }
    DateRangePickerComponent.prototype.ngOnInit = function () {
        this.onInit();
        this.element = $(this.ele.nativeElement).find('.form-control');
        if (this.element.hasClass('dropup'))
            this.drops = 'up';
        this.locale = {
            direction: 'ltr',
            format: 'MM/DD/YYYY',
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek(),
        };
        this.callback = function () { };
        if (typeof this.template !== 'string' && !(this.template instanceof $))
            this.template = date_range_picker_helper_1.pickerTemplate;
        var container = this.parentEl.find('.daterangepicker');
        if (container.length === 0) {
            this.container = $(this.template).appendTo(this.parentEl);
        }
        else {
            this.container = container;
        }
        this._handleOverrides();
        this._processInitialValues();
        this._processTimePicker();
        if (this.autoApply && typeof this.ranges !== 'object') {
            this.container.find('.ranges').hide();
        }
        else if (this.autoApply) {
            this.container.find('.applyBtn, .cancelBtn').addClass('hide');
        }
        this._processSingleDatePicker();
        if ((typeof this.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
            this.container.addClass('show-calendar');
        }
        this.container.addClass('opens' + this.opens);
        if (typeof this.ranges !== 'undefined' && this.opens === 'right') {
            this.container.find('.ranges').prependTo(this.container.find('.calendar.left').parent());
        }
        this._processCssForLabelsAndButtons();
        this._processEventListeners();
        this._processInitialValue();
    };
    DateRangePickerComponent.prototype.ngOnDestroy = function () {
        this.remove();
    };
    DateRangePickerComponent.prototype.addValidators = function () { };
    DateRangePickerComponent.prototype._handleOverrides = function () {
        if (typeof this.locale === 'object') {
            if (typeof this.locale.direction === 'string')
                this.locale.direction = this.locale.direction;
            if (typeof this.locale.format === 'string')
                this.locale.format = this.locale.format;
            if (typeof this.locale.separator === 'string')
                this.locale.separator = this.locale.separator;
            if (typeof this.locale.daysOfWeek === 'object')
                this.locale.daysOfWeek = this.locale.daysOfWeek.slice();
            if (typeof this.locale.monthNames === 'object')
                this.locale.monthNames = this.locale.monthNames.slice();
            if (typeof this.locale.firstDay === 'number')
                this.locale.firstDay = this.locale.firstDay;
            if (typeof this.locale.applyLabel === 'string')
                this.locale.applyLabel = this.locale.applyLabel;
            if (typeof this.locale.cancelLabel === 'string')
                this.locale.cancelLabel = this.locale.cancelLabel;
            if (typeof this.locale.weekLabel === 'string')
                this.locale.weekLabel = this.locale.weekLabel;
            if (typeof this.locale.customRangeLabel === 'string')
                this.locale.customRangeLabel = this.locale.customRangeLabel;
        }
        this.container.addClass(this.locale.direction);
        if (typeof this.startDate === 'string')
            this.startDate = moment(this.startDate, this.locale.format);
        if (typeof this.endDate === 'string')
            this.endDate = moment(this.endDate, this.locale.format);
        if (typeof this.minDate === 'string')
            this.minDate = moment(this.minDate, this.locale.format);
        if (typeof this.maxDate === 'string')
            this.maxDate = moment(this.maxDate, this.locale.format);
        if (typeof this.startDate === 'object')
            this.startDate = moment(this.startDate);
        if (typeof this.endDate === 'object')
            this.endDate = moment(this.endDate);
        if (typeof this.minDate === 'object')
            this.minDate = moment(this.minDate);
        if (typeof this.maxDate === 'object')
            this.maxDate = moment(this.maxDate);
        if (this.minDate && this.startDate.isBefore(this.minDate))
            this.startDate = this.minDate.clone();
        if (this.maxDate && this.endDate.isAfter(this.maxDate))
            this.endDate = this.maxDate.clone();
        if (typeof this.applyClass === 'string')
            this.applyClass = this.applyClass;
        if (typeof this.cancelClass === 'string')
            this.cancelClass = this.cancelClass;
        if (typeof this.dateLimit === 'object')
            this.dateLimit = this.dateLimit;
        if (typeof this.opens === 'string')
            this.opens = this.opens;
        if (typeof this.drops === 'string')
            this.drops = this.drops;
        if (typeof this.showWeekNumbers === 'boolean')
            this.showWeekNumbers = this.showWeekNumbers;
        if (typeof this.showISOWeekNumbers === 'boolean')
            this.showISOWeekNumbers = this.showISOWeekNumbers;
        if (typeof this.buttonClasses === 'string')
            this.buttonClasses = this.buttonClasses;
        if (typeof this.buttonClasses === 'object')
            this.buttonClasses = this.buttonClasses.join(' ');
        if (typeof this.showDropdowns === 'boolean')
            this.showDropdowns = this.showDropdowns;
        if (typeof this.showCustomRangeLabel === 'boolean')
            this.showCustomRangeLabel = this.showCustomRangeLabel;
        if (typeof this.singleDatePicker === 'boolean') {
            this.singleDatePicker = this.singleDatePicker;
            if (this.singleDatePicker)
                this.endDate = this.startDate.clone();
        }
        if (typeof this.timePicker === 'boolean')
            this.timePicker = this.timePicker;
        if (typeof this.timePickerSeconds === 'boolean')
            this.timePickerSeconds = this.timePickerSeconds;
        if (typeof this.timePickerIncrement === 'number')
            this.timePickerIncrement = this.timePickerIncrement;
        if (typeof this.timePicker24Hour === 'boolean')
            this.timePicker24Hour = this.timePicker24Hour;
        if (typeof this.autoApply === 'boolean')
            this.autoApply = this.autoApply;
        if (typeof this.autoUpdateInput === 'boolean')
            this.autoUpdateInput = this.autoUpdateInput;
        if (typeof this.linkedCalendars === 'boolean')
            this.linkedCalendars = this.linkedCalendars;
        if (typeof this.isInvalidDate === 'function')
            this.isInvalidDate = this.isInvalidDate;
        if (typeof this.isCustomDate === 'function')
            this.isCustomDate = this.isCustomDate;
        if (typeof this.alwaysShowCalendars === 'boolean')
            this.alwaysShowCalendars = this.alwaysShowCalendars;
        if (this.locale.firstDay !== 0) {
            var iterator = this.locale.firstDay;
            while (iterator > 0) {
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }
    };
    DateRangePickerComponent.prototype._processInitialValues = function () {
        var start, end;
        if (typeof this.startDate === 'undefined' && typeof this.endDate === 'undefined') {
            if ($(this.element).is('input[type=text]')) {
                var val = $(this.element).val(), split = val.split(this.locale.separator);
                start = end = null;
                if (split.length === 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                }
                else if (this.singleDatePicker && val !== '') {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }
        if (typeof this.ranges === 'object') {
            for (var range in this.ranges) {
                if (typeof this.ranges[range][0] === 'string') {
                    start = moment(this.ranges[range][0], this.locale.format);
                }
                else {
                    start = moment(this.ranges[range][0]);
                }
                if (typeof this.ranges[range][1] === 'string') {
                    end = moment(this.ranges[range][1], this.locale.format);
                }
                else {
                    end = moment(this.ranges[range][1]);
                }
                if (this.minDate && start.isBefore(this.minDate))
                    start = this.minDate.clone();
                var maxDate = this.maxDate;
                if (this.dateLimit && maxDate && start.clone().add(this.dateLimit).isAfter(maxDate))
                    maxDate = start.clone().add(this.dateLimit);
                if (maxDate && end.isAfter(maxDate))
                    end = maxDate.clone();
                if ((this.minDate && end.isBefore(this.minDate, this.timePicker ? 'minute' : 'day'))
                    || (maxDate && start.isAfter(maxDate, this.timePicker ? 'minute' : 'day')))
                    continue;
                var elem = document.createElement('textarea');
                elem.innerHTML = range;
                var rangeHtml = elem.value;
                this.ranges[rangeHtml] = [start, end];
            }
            var list = '<ul>';
            for (var range in this.ranges) {
                list += '<li data-range-key="' + range + '">' + range + '</li>';
            }
            if (this.showCustomRangeLabel) {
                list += '<li class="btn btn-sm" data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
            }
            list += '</ul>';
            this.container.find('.ranges').prepend(list);
        }
    };
    DateRangePickerComponent.prototype._processSingleDatePicker = function () {
        if (this.singleDatePicker) {
            this.container.addClass('single');
            this.container.find('.calendar.left').addClass('single');
            this.container.find('.calendar.left').show();
            this.container.find('.calendar.right').hide();
            this.container.find('.daterangepicker_input input, .daterangepicker_input > i').hide();
            if (this.timePicker) {
                this.container.find('.ranges ul').hide();
            }
            else {
                this.container.find('.ranges').hide();
            }
        }
    };
    DateRangePickerComponent.prototype._processTimePicker = function () {
        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
            this.endDate = this.endDate.endOf('day');
            this.container.find('.calendar-time').hide();
        }
        if (this.timePicker && this.autoApply)
            this.autoApply = false;
    };
    DateRangePickerComponent.prototype._processCssForLabelsAndButtons = function () {
        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
        if (this.applyClass.length)
            this.container.find('.applyBtn').addClass(this.applyClass);
        if (this.cancelClass.length)
            this.container.find('.cancelBtn').addClass(this.cancelClass);
        this.container.find('.applyBtn').html(this.locale.applyLabel);
        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
    };
    DateRangePickerComponent.prototype._processEventListeners = function () {
        this.container.find('.calendar')
            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
            .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))
            .on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this))
            .on('focus.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsFocused, this))
            .on('blur.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsBlurred, this))
            .on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this));
        this.container.find('.ranges')
            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
            .on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this))
            .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));
        if (this.element.is('input') || this.element.is('button')) {
            this.element.on({
                'click.daterangepicker': $.proxy(this.show, this),
                'focus.daterangepicker': $.proxy(this.show, this),
                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
                'keydown.daterangepicker': $.proxy(this.keydown, this),
            });
        }
        else {
            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
        }
    };
    DateRangePickerComponent.prototype._processInitialValue = function () {
        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.element.trigger('change');
        }
        else if (this.element.is('input') && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format));
            this.element.trigger('change');
        }
    };
    DateRangePickerComponent.prototype.setStartDate = function (startDate) {
        if (typeof startDate === 'string')
            this.startDate = moment(startDate, this.locale.format);
        if (typeof startDate === 'object')
            this.startDate = moment(startDate);
        if (!this.timePicker)
            this.startDate = this.startDate.startOf('day');
        if (this.timePicker && this.timePickerIncrement)
            this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        if (this.minDate && this.startDate.isBefore(this.minDate)) {
            this.startDate = this.minDate;
            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }
        if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
            this.startDate = this.maxDate;
            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }
        if (!this.isShowing)
            this.updateElement();
        this.updateMonthsInView();
    };
    ;
    DateRangePickerComponent.prototype.setEndDate = function (endDate) {
        if (typeof endDate === 'string')
            this.endDate = moment(endDate, this.locale.format);
        if (typeof endDate === 'object')
            this.endDate = moment(endDate);
        if (!this.timePicker)
            this.endDate = this.endDate.endOf('day');
        if (this.timePicker && this.timePickerIncrement)
            this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        if (this.endDate.isBefore(this.startDate))
            this.endDate = this.startDate.clone();
        if (this.maxDate && this.endDate.isAfter(this.maxDate))
            this.endDate = this.maxDate;
        if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate))
            this.endDate = this.startDate.clone().add(this.dateLimit);
        this.previousRightTime = this.endDate.clone();
        if (!this.isShowing)
            this.updateElement();
        this.updateMonthsInView();
    };
    ;
    DateRangePickerComponent.prototype.isInvalidDate = function (options) {
        return false;
    };
    DateRangePickerComponent.prototype.isCustomDate = function (options) {
        return false;
    };
    ;
    DateRangePickerComponent.prototype.updateView = function () {
        if (this.timePicker) {
            this.renderTimePicker('left');
            this.renderTimePicker('right');
            if (!this.endDate) {
                this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
            }
            else {
                this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
            }
        }
        if (this.endDate) {
            this.container.find('input[name="daterangepicker_end"]').removeClass('active');
            this.container.find('input[name="daterangepicker_start"]').addClass('active');
        }
        else {
            this.container.find('input[name="daterangepicker_end"]').addClass('active');
            this.container.find('input[name="daterangepicker_start"]').removeClass('active');
        }
        this.updateMonthsInView();
        this.updateCalendars();
        this.updateFormInputs();
    };
    DateRangePickerComponent.prototype.updateMonthsInView = function () {
        if (this.endDate) {
            if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
                (this.startDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM'))
                &&
                    (this.endDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM'))) {
                return;
            }
            this.leftCalendar.month = this.startDate.clone().date(2);
            if (!this.linkedCalendars && (this.endDate.month() !== this.startDate.month() || this.endDate.year() !== this.startDate.year())) {
                this.rightCalendar.month = this.endDate.clone().date(2);
            }
            else {
                this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
            }
        }
        else {
            if (this.leftCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM')) {
                this.leftCalendar.month = this.startDate.clone().date(2);
                this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
            }
        }
        if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
            this.rightCalendar.month = this.maxDate.clone().date(2);
            this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
        }
    };
    DateRangePickerComponent.prototype.updateCalendars = function () {
        if (this.timePicker) {
            var hour, minute, second;
            if (this.endDate) {
                hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                if (!this.timePicker24Hour) {
                    var ampm = this.container.find('.left .ampmselect').val();
                    if (ampm === 'PM' && hour < 12)
                        hour += 12;
                    if (ampm === 'AM' && hour === 12)
                        hour = 0;
                }
            }
            else {
                hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                if (!this.timePicker24Hour) {
                    var ampm = this.container.find('.right .ampmselect').val();
                    if (ampm === 'PM' && hour < 12)
                        hour += 12;
                    if (ampm === 'AM' && hour === 12)
                        hour = 0;
                }
            }
            this.leftCalendar.month.hour(hour).minute(minute).second(second);
            this.rightCalendar.month.hour(hour).minute(minute).second(second);
        }
        this.renderCalendar('left');
        this.renderCalendar('right');
        this.container.find('.ranges li').removeClass('active');
        if (this.endDate == null)
            return;
        this.calculateChosenLabel();
    };
    DateRangePickerComponent.prototype.renderCalendar = function (side) {
        var calendar = side === 'left' ? this.leftCalendar : this.rightCalendar;
        var month = calendar.month.month();
        var year = calendar.month.year();
        var hour = calendar.month.hour();
        var minute = calendar.month.minute();
        var second = calendar.month.second();
        var daysInMonth = moment([year, month]).daysInMonth();
        var firstDay = moment([year, month, 1]);
        var lastDay = moment([year, month, daysInMonth]);
        var lastMonth = moment(firstDay).subtract(1, 'month').month();
        var lastYear = moment(firstDay).subtract(1, 'month').year();
        var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
        var dayOfWeek = firstDay.day();
        calendar.firstDay = firstDay;
        calendar.lastDay = lastDay;
        for (var i = 0; i < 6; i++) {
            calendar[i] = [];
        }
        var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
        if (startDay > daysInLastMonth)
            startDay -= 7;
        if (dayOfWeek === this.locale.firstDay)
            startDay = daysInLastMonth - 6;
        var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
        for (var i_1 = 0, col = 0, row = 0; i_1 < 42; i_1++, col++, curDate = moment(curDate).add(24, 'hour')) {
            if (i_1 > 0 && col % 7 === 0) {
                col = 0;
                row++;
            }
            calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
            curDate.hour(12);
            if (this.minDate && calendar[row][col].format('YYYY-MM-DD') === this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side === 'left') {
                calendar[row][col] = this.minDate.clone();
            }
            if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') === this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side === 'right') {
                calendar[row][col] = this.maxDate.clone();
            }
        }
        if (side === 'left') {
            this.leftCalendar.calendar = calendar;
        }
        else {
            this.rightCalendar.calendar = calendar;
        }
        var minDate = side === 'left' ? this.minDate : this.startDate;
        var maxDate = this.maxDate;
        var arrow = this.locale.direction === 'ltr' ? { left: 'chevron-left', right: 'chevron-right' } : { left: 'chevron-right', right: 'chevron-left' };
        var html = '<table class="table-condensed">';
        html += '<thead>';
        html += '<tr>';
        if (this.showWeekNumbers || this.showISOWeekNumbers)
            html += '<th></th>';
        if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side === 'left')) {
            html += '<th class="prev available"><i class="zmdi zmdi-' + arrow.left + '"></i></th>';
        }
        else {
            html += '<th></th>';
        }
        var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format('YYYY');
        if (this.showDropdowns) {
            var currentMonth = calendar[1][1].month();
            var currentYear = calendar[1][1].year();
            var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
            var minYear = (minDate && minDate.year()) || (currentYear - 50);
            var inMinYear = currentYear === minYear;
            var inMaxYear = currentYear === maxYear;
            var monthHtml = '<select class="monthselect">';
            for (var m = 0; m < 12; m++) {
                if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
                    monthHtml += '<option value="' + m + '"' +
                        (m === currentMonth ? ' selected="selected"' : '') +
                        '>' + this.locale.monthNames[m] + '</option>';
                }
                else {
                    monthHtml += '<option value="' + m + '"' +
                        (m === currentMonth ? ' selected="selected"' : '') +
                        ' disabled="disabled">' + this.locale.monthNames[m] + '</option>';
                }
            }
            monthHtml += '</select>';
            var yearHtml = '<select class="yearselect">';
            for (var y = minYear; y <= maxYear; y++) {
                yearHtml += '<option value="' + y + '"' +
                    (y === currentYear ? ' selected="selected"' : '') +
                    '>' + y + '</option>';
            }
            yearHtml += '</select>';
            dateHtml = monthHtml + yearHtml;
        }
        html += '<th colspan="5" class="month">' + dateHtml + '</th>';
        if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side === 'right' || this.singleDatePicker)) {
            html += '<th class="next available"><i class="zmdi zmdi-' + arrow.right + '"></i></th>';
        }
        else {
            html += '<th></th>';
        }
        html += '</tr>';
        html += '<tr>';
        if (this.showWeekNumbers || this.showISOWeekNumbers)
            html += '<th class="week">' + this.locale.weekLabel + '</th>';
        $.each(this.locale.daysOfWeek, function (index, dayOfWeek) {
            html += '<th>' + dayOfWeek + '</th>';
        });
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';
        if (this.endDate == null && this.dateLimit) {
            var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
            if (!maxDate || maxLimit.isBefore(maxDate)) {
                maxDate = maxLimit;
            }
        }
        for (var row = 0; row < 6; row++) {
            html += '<tr>';
            if (this.showWeekNumbers) {
                html += '<td class="week">' + calendar[row][0].week() + '</td>';
            }
            else if (this.showISOWeekNumbers)
                html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';
            for (var col = 0; col < 7; col++) {
                var classes = new Array();
                if (calendar[row][col].isSame(new Date(), 'day'))
                    classes.push('today');
                if (calendar[row][col].isoWeekday() > 5)
                    classes.push('weekend');
                if (calendar[row][col].month() !== calendar[1][1].month())
                    classes.push('off');
                if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
                    classes.push('off', 'disabled');
                if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
                    classes.push('off', 'disabled');
                if (this.isInvalidDate(calendar[row][col]))
                    classes.push('off', 'disabled');
                if (calendar[row][col].format('YYYY-MM-DD') === this.startDate.format('YYYY-MM-DD'))
                    classes.push('active', 'start-date');
                if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') === this.endDate.format('YYYY-MM-DD'))
                    classes.push('active', 'end-date');
                if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
                    classes.push('in-range');
                var isCustom = this.isCustomDate(calendar[row][col]);
                if (isCustom !== false) {
                    if (typeof isCustom === 'string') {
                        classes.push(String(isCustom));
                    }
                    else
                        Array.prototype.push.apply(classes, isCustom);
                }
                var cname = '', disabled = false;
                for (var i = 0; i < classes.length; i++) {
                    cname += classes[i] + ' ';
                    if (classes[i] === 'disabled')
                        disabled = true;
                }
                if (!disabled)
                    cname += 'available';
                html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
            }
            html += '</tr>';
        }
        html += '</tbody>';
        html += '</table>';
        this.container.find('.calendar.' + side + ' .calendar-table').html(html);
    };
    DateRangePickerComponent.prototype.renderTimePicker = function (side) {
        if (side === 'right' && !this.endDate)
            return;
        var html, selected, minDate, maxDate = this.maxDate;
        if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate)))
            maxDate = this.startDate.clone().add(this.dateLimit);
        if (side === 'left') {
            selected = this.startDate.clone();
            minDate = this.minDate;
        }
        else if (side === 'right') {
            selected = this.endDate.clone();
            minDate = this.startDate;
            var timeSelector = this.container.find('.calendar.right .calendar-time div');
            if (!this.endDate && timeSelector.html() !== '') {
                selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
                selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
                selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());
                if (!this.timePicker24Hour) {
                    var ampm = timeSelector.find('.ampmselect option:selected').val();
                    if (ampm === 'PM' && selected.hour() < 12)
                        selected.hour(selected.hour() + 12);
                    if (ampm === 'AM' && selected.hour() === 12)
                        selected.hour(0);
                }
            }
            if (selected.isBefore(this.startDate))
                selected = this.startDate.clone();
            if (maxDate && selected.isAfter(maxDate))
                selected = maxDate.clone();
        }
        html = '<select class="hourselect">';
        var start = this.timePicker24Hour ? 0 : 1;
        var end = this.timePicker24Hour ? 23 : 12;
        for (var i = start; i <= end; i++) {
            var i_in_24 = i;
            if (!this.timePicker24Hour)
                i_in_24 = selected.hour() >= 12 ? (i === 12 ? 12 : i + 12) : (i === 12 ? 0 : i);
            var time = selected.clone().hour(i_in_24);
            var disabled = false;
            if (minDate && time.minute(59).isBefore(minDate))
                disabled = true;
            if (maxDate && time.minute(0).isAfter(maxDate))
                disabled = true;
            if (i_in_24 === selected.hour() && !disabled) {
                html += '<option value="' + i + '" selected="selected">' + i + '</option>';
            }
            else if (disabled) {
                html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
            }
            else {
                html += '<option value="' + i + '">' + i + '</option>';
            }
        }
        html += '</select> ';
        html += ': <select class="minuteselect">';
        for (var i = 0; i < 60; i += this.timePickerIncrement) {
            var padded = i < 10 ? '0' + i : i;
            var time = selected.clone().minute(i);
            var disabled = false;
            if (minDate && time.second(59).isBefore(minDate))
                disabled = true;
            if (maxDate && time.second(0).isAfter(maxDate))
                disabled = true;
            if (selected.minute() === i && !disabled) {
                html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
            }
            else if (disabled) {
                html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
            }
            else {
                html += '<option value="' + i + '">' + padded + '</option>';
            }
        }
        html += '</select> ';
        if (this.timePickerSeconds) {
            html += ': <select class="secondselect">';
            for (var i = 0; i < 60; i++) {
                var padded = i < 10 ? '0' + i : i;
                var time = selected.clone().second(i);
                var disabled = false;
                if (minDate && time.isBefore(minDate))
                    disabled = true;
                if (maxDate && time.isAfter(maxDate))
                    disabled = true;
                if (selected.second() === i && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                }
                else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                }
                else {
                    html += '<option value="' + i + '">' + padded + '</option>';
                }
            }
            html += '</select> ';
        }
        if (!this.timePicker24Hour) {
            html += '<select class="ampmselect">';
            var am_html = '';
            var pm_html = '';
            if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
                am_html = ' disabled="disabled" class="disabled"';
            if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
                pm_html = ' disabled="disabled" class="disabled"';
            if (selected.hour() >= 12) {
                html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
            }
            else {
                html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
            }
            html += '</select>';
        }
        this.container.find('.calendar.' + side + ' .calendar-time div').html(html);
    };
    DateRangePickerComponent.prototype.updateFormInputs = function () {
        if (this.container.find('input[name=daterangepicker_start]').is(':focus') || this.container.find('input[name=daterangepicker_end]').is(':focus'))
            return;
        this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
        if (this.endDate)
            this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));
        if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
            this.container.find('button.applyBtn').removeAttr('disabled');
        }
        else {
            this.container.find('button.applyBtn').attr('disabled', 'disabled');
        }
    };
    DateRangePickerComponent.prototype.move = function () {
        var parentOffset = { top: 0, left: 0 }, containerTop;
        var parentRightEdge = $(window).width();
        if (!this.parentEl.is('body')) {
            parentOffset = {
                top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                left: this.parentEl.offset().left - this.parentEl.scrollLeft(),
            };
            parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
        }
        if (this.drops === 'up') {
            containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
        }
        else {
            containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
        }
        this.container[this.drops === 'up' ? 'addClass' : 'removeClass']('dropup');
        if (this.opens === 'left') {
            this.container.css({
                top: containerTop,
                right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
                left: 'auto',
            });
            if (this.container.offset().left < 0) {
                this.container.css({
                    right: 'auto',
                    left: 9,
                });
            }
        }
        else if (this.opens === 'center') {
            this.container.css({
                top: containerTop,
                left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
                    - this.container.outerWidth() / 2,
                right: 'auto',
            });
            if (this.container.offset().left < 0) {
                this.container.css({
                    right: 'auto',
                    left: 9,
                });
            }
        }
        else {
            this.container.css({
                top: containerTop,
                left: this.element.offset().left - parentOffset.left,
                right: 'auto',
            });
            if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
                this.container.css({
                    left: 'auto',
                    right: 0,
                });
            }
        }
    };
    DateRangePickerComponent.prototype.show = function (e) {
        if (this.isShowing)
            return;
        this._outsideClickProxy = $.proxy(function (e) { this.outsideClick(e); }, this);
        $(document)
            .on('mousedown.daterangepicker', this._outsideClickProxy)
            .on('touchend.daterangepicker', this._outsideClickProxy)
            .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
            .on('focusin.daterangepicker', this._outsideClickProxy);
        $(window).on('resize.daterangepicker', $.proxy(function (e) { this.move(e); }, this));
        this.oldStartDate = this.startDate.clone();
        this.oldEndDate = this.endDate.clone();
        this.previousRightTime = this.endDate.clone();
        this.updateView();
        this.container.show();
        this.move();
        this.element.trigger('show.daterangepicker', this);
        this.isShowing = true;
    };
    DateRangePickerComponent.prototype.hide = function (e) {
        if (!this.isShowing)
            return;
        if (!this.endDate) {
            this.startDate = this.oldStartDate.clone();
            this.endDate = this.oldEndDate.clone();
        }
        if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
            this.callback(this.startDate, this.endDate, this.chosenLabel);
        this.updateElement();
        $(document).off('.daterangepicker');
        $(window).off('.daterangepicker');
        this.container.hide();
        this.element.trigger('hide.daterangepicker', this);
        this.isShowing = false;
    };
    DateRangePickerComponent.prototype.toggle = function (e) {
        if (this.isShowing) {
            this.hide();
        }
        else {
            this.show();
        }
    };
    DateRangePickerComponent.prototype.outsideClick = function (e) {
        var target = $(e.target);
        if (e.type === 'focusin' ||
            target.closest(this.element).length ||
            target.closest(this.container).length ||
            target.closest('.calendar-table').length)
            return;
        this.hide();
        this.element.trigger('outsideClick.daterangepicker', this);
    };
    DateRangePickerComponent.prototype.showCalendars = function () {
        this.container.addClass('show-calendar');
        this.move();
        this.element.trigger('showCalendar.daterangepicker', this);
    };
    DateRangePickerComponent.prototype.hideCalendars = function () {
        this.container.removeClass('show-calendar');
        this.element.trigger('hideCalendar.daterangepicker', this);
    };
    DateRangePickerComponent.prototype.hoverRange = function (e) {
        if (this.container.find('input[name=daterangepicker_start]').is(':focus') || this.container.find('input[name=daterangepicker_end]').is(':focus'))
            return;
        var label = e.target.getAttribute('data-range-key');
        if (label === this.locale.customRangeLabel) {
            this.updateView();
        }
        else {
            var dates = this.ranges[label];
            this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
            this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
        }
    };
    DateRangePickerComponent.prototype.clickRange = function (e) {
        var label = e.target.getAttribute('data-range-key');
        this.chosenLabel = label;
        if (label === this.locale.customRangeLabel) {
            this.showCalendars();
        }
        else {
            var dates = this.ranges[label];
            this.startDate = dates[0];
            this.endDate = dates[1];
            if (!this.timePicker) {
                this.startDate.startOf('day');
                this.endDate.endOf('day');
            }
            if (!this.alwaysShowCalendars)
                this.hideCalendars();
            this.clickApply();
        }
    };
    DateRangePickerComponent.prototype.clickPrev = function (e) {
        var cal = $(e.target).parents('.calendar');
        if (cal.hasClass('left')) {
            this.leftCalendar.month.subtract(1, 'month');
            if (this.linkedCalendars)
                this.rightCalendar.month.subtract(1, 'month');
        }
        else {
            this.rightCalendar.month.subtract(1, 'month');
        }
        this.updateCalendars();
    };
    DateRangePickerComponent.prototype.clickNext = function (e) {
        var cal = $(e.target).parents('.calendar');
        if (cal.hasClass('left')) {
            this.leftCalendar.month.add(1, 'month');
        }
        else {
            this.rightCalendar.month.add(1, 'month');
            if (this.linkedCalendars)
                this.leftCalendar.month.add(1, 'month');
        }
        this.updateCalendars();
    };
    DateRangePickerComponent.prototype.hoverDate = function (e) {
        if (!$(e.target).hasClass('available'))
            return;
        var title = $(e.target).attr('data-title');
        var row = title.substr(1, 1);
        var col = title.substr(3, 1);
        var cal = $(e.target).parents('.calendar');
        var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
        if (this.endDate && !this.container.find('input[name=daterangepicker_start]').is(':focus')) {
            this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
        }
        else if (!this.endDate && !this.container.find('input[name=daterangepicker_end]').is(':focus')) {
            this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
        }
        var leftCalendar = this.leftCalendar;
        var rightCalendar = this.rightCalendar;
        var startDate = this.startDate;
        if (!this.endDate) {
            this.container.find('.calendar td').each(function (index, el) {
                if ($(el).hasClass('week'))
                    return;
                var title = $(el).attr('data-title');
                var row = title.substr(1, 1);
                var col = title.substr(3, 1);
                var cal = $(el).parents('.calendar');
                var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
                if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
                    $(el).addClass('in-range');
                }
                else {
                    $(el).removeClass('in-range');
                }
            });
        }
    };
    DateRangePickerComponent.prototype.clickDate = function (e) {
        if (!$(e.target).hasClass('available'))
            return;
        var title = $(e.target).attr('data-title');
        var row = title.substr(1, 1);
        var col = title.substr(3, 1);
        var cal = $(e.target).parents('.calendar');
        var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
        if (this.endDate || date.isBefore(this.startDate, 'day')) {
            if (this.timePicker) {
                var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                if (!this.timePicker24Hour) {
                    var ampm = this.container.find('.left .ampmselect').val();
                    if (ampm === 'PM' && hour < 12)
                        hour += 12;
                    if (ampm === 'AM' && hour === 12)
                        hour = 0;
                }
                var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                date = date.clone().hour(hour).minute(minute).second(second);
            }
            this.endDate = null;
            this.setStartDate(date.clone());
        }
        else if (!this.endDate && date.isBefore(this.startDate)) {
            this.setEndDate(this.startDate.clone());
        }
        else {
            if (this.timePicker) {
                var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                if (!this.timePicker24Hour) {
                    var ampm = this.container.find('.right .ampmselect').val();
                    if (ampm === 'PM' && hour < 12)
                        hour += 12;
                    if (ampm === 'AM' && hour === 12)
                        hour = 0;
                }
                var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                date = date.clone().hour(hour).minute(minute).second(second);
            }
            this.setEndDate(date.clone());
            if (this.autoApply) {
                this.calculateChosenLabel();
                this.clickApply();
            }
        }
        if (this.singleDatePicker) {
            this.setEndDate(this.startDate);
            if (!this.timePicker)
                this.clickApply();
        }
        this.updateView();
        e.stopPropagation();
    };
    DateRangePickerComponent.prototype.calculateChosenLabel = function () {
        var customRange = true;
        var i = 0;
        for (var range in this.ranges) {
            if (this.timePicker) {
                if (this.startDate.isSame(this.ranges[range][0]) && this.endDate.isSame(this.ranges[range][1])) {
                    customRange = false;
                    this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
                    break;
                }
            }
            else {
                if (this.startDate.format('YYYY-MM-DD') === this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') === this.ranges[range][1].format('YYYY-MM-DD')) {
                    customRange = false;
                    this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
                    break;
                }
            }
            i++;
        }
        if (customRange && this.showCustomRangeLabel) {
            this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
            this.showCalendars();
        }
    };
    DateRangePickerComponent.prototype.clickApply = function (e) {
        this.hide();
        this.element.trigger('apply.daterangepicker', this);
        this.updateControlValue();
    };
    DateRangePickerComponent.prototype.updateControlValue = function () {
        var startDate = this.startDate.format(this.locale.format);
        var endDate = this.endDate.format(this.locale.format);
        this.control.setValue(startDate + " - " + endDate);
        this.rangeChanged.emit(new date_range_1.DateRange(this.startDate.clone(), this.endDate.clone()));
    };
    DateRangePickerComponent.prototype.clickCancel = function (e) {
        this.startDate = this.oldStartDate;
        this.endDate = this.oldEndDate;
        this.hide();
        this.element.trigger('cancel.daterangepicker', this);
    };
    DateRangePickerComponent.prototype.monthOrYearChanged = function (e) {
        var isLeft = $(e.target).closest('.calendar').hasClass('left'), leftOrRight = isLeft ? 'left' : 'right', cal = this.container.find('.calendar.' + leftOrRight);
        var month = parseInt(cal.find('.monthselect').val(), 10);
        var year = cal.find('.yearselect').val();
        if (!isLeft) {
            if (year < this.startDate.year() || (year === this.startDate.year() && month < this.startDate.month())) {
                month = this.startDate.month();
                year = this.startDate.year();
            }
        }
        if (this.minDate) {
            if (year < this.minDate.year() || (year === this.minDate.year() && month < this.minDate.month())) {
                month = this.minDate.month();
                year = this.minDate.year();
            }
        }
        if (this.maxDate) {
            if (year > this.maxDate.year() || (year === this.maxDate.year() && month > this.maxDate.month())) {
                month = this.maxDate.month();
                year = this.maxDate.year();
            }
        }
        if (isLeft) {
            this.leftCalendar.month.month(month).year(year);
            if (this.linkedCalendars)
                this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
        }
        else {
            this.rightCalendar.month.month(month).year(year);
            if (this.linkedCalendars)
                this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
        }
        this.updateCalendars();
    };
    DateRangePickerComponent.prototype.timeChanged = function (e) {
        var cal = $(e.target).closest('.calendar'), isLeft = cal.hasClass('left');
        var hour = parseInt(cal.find('.hourselect').val(), 10);
        var minute = parseInt(cal.find('.minuteselect').val(), 10);
        var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;
        if (!this.timePicker24Hour) {
            var ampm = cal.find('.ampmselect').val();
            if (ampm === 'PM' && hour < 12)
                hour += 12;
            if (ampm === 'AM' && hour === 12)
                hour = 0;
        }
        if (isLeft) {
            var start = this.startDate.clone();
            start.hour(hour);
            start.minute(minute);
            start.second(second);
            this.setStartDate(start);
            if (this.singleDatePicker) {
                this.endDate = this.startDate.clone();
            }
            else if (this.endDate && this.endDate.format('YYYY-MM-DD') === start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
                this.setEndDate(start.clone());
            }
        }
        else if (this.endDate) {
            var end = this.endDate.clone();
            end.hour(hour);
            end.minute(minute);
            end.second(second);
            this.setEndDate(end);
        }
        this.updateCalendars();
        this.updateFormInputs();
        this.renderTimePicker('left');
        this.renderTimePicker('right');
    };
    DateRangePickerComponent.prototype.formInputsChanged = function (e) {
        var isRight = $(e.target).closest('.calendar').hasClass('right');
        var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
        var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);
        if (start.isValid() && end.isValid()) {
            if (isRight && end.isBefore(start))
                start = end.clone();
            this.setStartDate(start);
            this.setEndDate(end);
            if (isRight) {
                this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
            }
            else {
                this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
            }
        }
        this.updateView();
    };
    DateRangePickerComponent.prototype.formInputsFocused = function (e) {
        this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass('active');
        $(e.target).addClass('active');
        var isRight = $(e.target).closest('.calendar').hasClass('right');
        if (isRight) {
            this.endDate = null;
            this.setStartDate(this.startDate.clone());
            this.updateView();
        }
    };
    DateRangePickerComponent.prototype.formInputsBlurred = function (e) {
        if (!this.endDate) {
            var val = this.container.find('input[name="daterangepicker_end"]').val();
            var end = moment(val, this.locale.format);
            if (end.isValid()) {
                this.setEndDate(end);
                this.updateView();
            }
        }
    };
    DateRangePickerComponent.prototype.elementChanged = function () {
        if (!this.element.is('input'))
            return;
        if (!this.element.val().length)
            return;
        if (this.element.val().length < this.locale.format.length)
            return;
        var dateString = this.element.val().split(this.locale.separator), start = null, end = null;
        if (dateString.length === 2) {
            start = moment(dateString[0], this.locale.format);
            end = moment(dateString[1], this.locale.format);
        }
        if (this.singleDatePicker || start === null || end === null) {
            start = moment(this.element.val(), this.locale.format);
            end = start;
        }
        if (!start.isValid() || !end.isValid())
            return;
        this.setStartDate(start);
        this.setEndDate(end);
        this.updateView();
    };
    DateRangePickerComponent.prototype.keydown = function (e) {
        if ((e.keyCode === 9) || (e.keyCode === 13)) {
            this.hide();
        }
    };
    DateRangePickerComponent.prototype.updateElement = function () {
        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.element.trigger('change');
        }
        else if (this.element.is('input') && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format));
            this.element.trigger('change');
        }
    };
    DateRangePickerComponent.prototype.remove = function () {
        this.container.remove();
        this.element.off('.daterangepicker');
        this.element.removeData();
    };
    return DateRangePickerComponent;
}(input_base_component_1.InputBase));
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], DateRangePickerComponent.prototype, "fg", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateRangePickerComponent.prototype, "placeholder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateRangePickerComponent.prototype, "field", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateRangePickerComponent.prototype, "label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "parentEl", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "startDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "endDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "minDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "maxDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "dateLimit", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "autoApply", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "singleDatePicker", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "showDropdowns", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "showWeekNumbers", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "showISOWeekNumbers", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "showCustomRangeLabel", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "timePicker", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "timePicker24Hour", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DateRangePickerComponent.prototype, "timePickerIncrement", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "timePickerSeconds", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "linkedCalendars", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "autoUpdateInput", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateRangePickerComponent.prototype, "alwaysShowCalendars", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "ranges", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateRangePickerComponent.prototype, "buttonClasses", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateRangePickerComponent.prototype, "applyClass", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateRangePickerComponent.prototype, "cancelClass", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "template", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "locale", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateRangePickerComponent.prototype, "opens", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateRangePickerComponent.prototype, "drops", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], DateRangePickerComponent.prototype, "rangeChanged", void 0);
DateRangePickerComponent = __decorate([
    core_1.Component({
        selector: 'date-range-picker',
        template: "\n      <div class=\"input-group m-b-15 w-100\" [class.fg-float]=\"floatingLabel\" [class.fc-alt]=\"alt\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><label *ngIf=\"label &amp;&amp; !floatingLabel\">{{label}}</label><span class=\"input-group-addon\" *ngIf=\"leftIcon\"><i class=\"zmdi zmdi-{{leftIcon}}\"></i></span><div class=\"fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><input class=\"form-control\" #i [type]=\"inputType\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" [disabled]=\"disabled\" (focus)=\"onFocus(i)\" (blur)=\"onBlur(i)\"><label class=\"fg-label\" *ngIf=\"label &amp;&amp; floatingLabel\">{{label}}</label></div><span class=\"input-group-addon last\" *ngIf=\"rightIcon\"><i class=\"zmdi zmdi-{{rightIcon}}\"></i></span><div *ngIf=\"!control.valid &amp;&amp; (control.dirty || fg.submitted)\"><small class=\"help-block animated fadeInDown\" *ngFor=\"let v of validations\" [class.hidden]=\"!control.errors[v.type]\">{{v.message}}</small></div></div>\n    ",
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], DateRangePickerComponent);
exports.DateRangePickerComponent = DateRangePickerComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/forms/date-range-picker/date-range-picker.component.js
// module id = 47
// module chunks = 0